import {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {REGISTRATIONS} from "../locales/namespaces";
import useUserData from "../../../hooks/user/useUserData";
import {API} from "../../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../../helpers/errorHandling";

const useMobileIndex = ()=>{
    const { t } = useTranslation(REGISTRATIONS)
    const { token, roles } = useUserData()
    const [indexData, setIndexData] = useState([])
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        axios({
            method:'post',
            headers:{ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            url:  `${API}/en/fts/project/work/index`
        }).then(response =>{
            const data  = response.data.result
            setIndexData(data)
            console.log('data',data)
            setLoading(false)
        }).catch((error)=>{
            enqueueSnackbar(handleAxiosErrors(error), {
                variant: 'warning',
                autoHideDuration: 9000,
            })
            setLoading(false)
        })
    }, []);
    return {
        loading,
        indexData
    }
}
export default useMobileIndex